import React from 'react';
import { AppsKlaviyoView } from './AppsKlaviyoView';
import { useKlaviyo } from './hooks/useKlaviyo';
export const AppsKlaviyo = () => {
    const { klaviyo } = useKlaviyo();
    return React.createElement(AppsKlaviyoView, { connectBar: klaviyo.connectBar });
};
